// fulcrum-core's Feature type doesn't expose coordinate properties in its TS declarations,
// but they exist at runtime on every Feature/Record instance.
export interface FeatureCoordinates {
  hasCoordinate: boolean;
  latitude: number;
  longitude: number;
}

export const hasFeatureCoordinates = (f: unknown): FeatureCoordinates | false => {
  if (f != null && (f as FeatureCoordinates).hasCoordinate === true) {
    return f as FeatureCoordinates;
  }
  return false;
};
